// extracted by mini-css-extract-plugin
export default {"uploadImageWrapper":"CreateExpenseModal_uploadImageWrapper__0GLDn","imageError":"CreateExpenseModal_imageError__An4SL"};